import { motion } from 'framer-motion';
import { Droplet } from 'lucide-react';
import SEO from '../../components/SEO';
import heroImage from '../../assets/waterproofing-hero.png';

const Waterproofing = () => {
    return (
        <div className="min-h-screen pb-20">
            <SEO 
                title="White Cement & Waterproofing Madurai" 
                description="Expert terrace and wall waterproofing in Madurai. Stop dampness and leakage today." 
            />
            
            {/* Hero Section */}
            <section className="relative h-[60vh] flex items-center justify-center overflow-hidden">
                <div className="absolute inset-0 z-0">
                    <img src={heroImage} alt="Waterproofing Work" className="w-full h-full object-cover" />
                    <div className="absolute inset-0 bg-blue-900/70"></div>
                </div>
                <div className="relative z-10 text-center px-4">
                    <motion.h1 
                        initial={{ opacity: 0, scale: 0.9 }}
                        animate={{ opacity: 1, scale: 1 }}
                        className="text-4xl md:text-6xl font-bold text-white mb-4"
                    >
                        Waterproofing Solutions
                    </motion.h1>
                    <motion.p 
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ delay: 0.3 }}
                        className="text-xl text-blue-100 italic"
                    >
                        "Stopping leaks before they start."
                    </motion.p>
                </div>
            </section>

            <div className="max-w-4xl mx-auto px-4 mt-20">
                <motion.div 
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    className="bg-white p-10 rounded-[2rem] shadow-xl border border-slate-100 mb-16"
                >
                    <h2 className="text-3xl font-bold text-blue-900 mb-6">Advanced Sealant & Waterproofing</h2>
                    <p className="text-gray-600 mb-10 leading-relaxed text-lg">
                        Damp walls and terrace leakages can damage your building's foundation. Our waterproofing experts in Madurai use industry-leading chemicals (Dr. Fixit, Asian Paints Damp Proof) to ensure your home stays dry and safe forever.
                    </p>

                    <div className="space-y-6">
                        <motion.div 
                            whileHover={{ x: 10 }}
                            className="flex items-start space-x-4 p-8 bg-blue-50 rounded-[2rem] border-l-8 border-blue-900 shadow-sm"
                        >
                            <Droplet className="text-blue-900 flex-shrink-0" size={32} />
                            <div>
                                <h4 className="font-bold text-blue-900 text-xl mb-1">Terrace Waterproofing</h4>
                                <p className="text-gray-600">Multi-layer protection for roof terraces to prevent seepage during heavy monsoon rains.</p>
                            </div>
                        </motion.div>
                        <motion.div 
                            whileHover={{ x: 10 }}
                            className="flex items-start space-x-4 p-8 bg-orange-50 rounded-[2rem] border-l-8 border-orange-600 shadow-sm"
                        >
                            <Droplet className="text-orange-600 flex-shrink-0" size={32} />
                            <div>
                                <h4 className="font-bold text-blue-900 text-xl mb-1">Wall Dampness Treatment</h4>
                                <p className="text-gray-600">Fixing moisture issues from the source and applying protective white cement coating.</p>
                            </div>
                        </motion.div>
                    </div>
                </motion.div>

                <motion.div 
                    initial={{ opacity: 0 }}
                    whileInView={{ opacity: 1 }}
                    className="bg-slate-900 text-white p-16 rounded-[3rem] text-center shadow-2xl relative overflow-hidden"
                >
                    <div className="absolute inset-0 bg-gradient-to-r from-blue-900/50 to-orange-900/50"></div>
                    <div className="relative z-10">
                        <h3 className="text-3xl font-bold mb-6">Protect Your Investment</h3>
                        <p className="text-gray-300 text-lg mb-8 max-w-2xl mx-auto font-medium">Get a professional inspection from SSS Waterproofing experts today and save your walls from damage.</p>
                        <a href="/contact" className="inline-block bg-orange-600 hover:bg-orange-700 text-white px-10 py-3 rounded-full font-bold shadow-xl transition-all">Free Site Visit</a>
                    </div>
                </motion.div>
            </div>
        </div>
    );
};

export default Waterproofing;
